export default "__VITE_ASSET__CtJ9Unrd__"